import React from 'react'

class SearchGlass extends React.Component {
  render() {
    return (
      <svg
        className="searchGlass"
        fill="#FFF"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <path d="M21.896 18.181l4.946 4.946a2.75 2.75 0 0 1-3.89 3.889l-5.1-5.101A10.457 10.457 0 0 1 13 23.1c-5.8 0-10.4-4.7-10.5-10.5C2.5 6.8 7.2 2.1 13 2.1s10.5 4.7 10.5 10.5c0 2.051-.588 3.964-1.604 5.581zM13 21.3c4.8 0 8.7-3.9 8.7-8.7 0-4.8-3.9-8.7-8.7-8.7-4.8 0-8.7 3.9-8.7 8.7 0 4.8 3.9 8.7 8.7 8.7zm11.367 4.302a.75.75 0 0 0 1.06-1.061l-4.207-4.207-1.06 1.06 4.207 4.208z" />
      </svg>
    )
  }
}

export default SearchGlass
